import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'

import {MasterLayout} from '@_metronic/layout/MasterLayout'
import {DashboardWrapper} from '@pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '@pages/MenuTestPage'
import {getCSSVariableValue} from '@_metronic/assets/ts/_utils'
import {WithChildren} from '@_metronic/helpers'
import LayoutBuilderPageWrapper from '@pages/LayoutBuilder/LayoutBuilderPageWrapper'
import Diaries from '@pages/Diaries'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const DynastyPage = lazy(() => import('../modules/dynasty/DynastyPage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const Gallery = lazy(() => import('@pages/Gallery'))
  const CultsPage = lazy(() => import('@pages/CultsPage'))
  const RelationsPage = lazy(() => import('@pages/RelationsPage'))
  const TagsPage = lazy(() => import('@pages/TagsPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/crafted/pages/dynasty/tree' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<LayoutBuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/dynasty/*'
          element={
            <SuspensedView>
              <DynastyPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/gallery/*'
          element={
            <SuspensedView>
              <Gallery />
            </SuspensedView>
          }
        />
        {/* <Route
          path='crafted/pages/diaries/*'
          element={
            <SuspensedView>
              <Diaries />
            </SuspensedView>
          }
        /> */}
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/pages/handbooks/cults'
          element={
            <SuspensedView>
              <CultsPage />
            </SuspensedView>
          }
        />
          <Route
              path='crafted/pages/handbooks/tags'
              element={
                  <SuspensedView>
                      <TagsPage />
                  </SuspensedView>
              }
          />
        <Route
          path='crafted/pages/handbooks/relations'
          element={
            <SuspensedView>
              <RelationsPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
